import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
    const slider = section.querySelector('[data-product-recommendations-slider]');
    const pagination = section.querySelector('[data-product-recommendations-pagination]');

    if (!slider || slider.dataset.productRecommendationsReady === 'true') {
        return;
    }

    slider.dataset.productRecommendationsReady = 'true';

    new Swiper(slider, {
        modules: [Pagination],
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        observer: true,
        observeParents: true,
        roundLengths: true,
        threshold: 5,
        watchOverflow: true,
        pagination: pagination
            ? {
                  el: pagination,
                  clickable: true,
              }
            : undefined,
    });
});
